import * as React from "react";
import { toJS } from "mobx";
import { TravelersPicker } from "./TravelersPicker";
import { TravelersContentProps, Travelers } from "../typings";

export const TravelersContent = (props: TravelersContentProps) => {
  const roomRefs: Array<React.RefObject<HTMLHeadingElement>> = [];

  const [totalRoomRefs, setTotalRoomRefs] = React.useState<number>(0);
  const [travelers, setTravelers] = React.useState<Travelers>(toJS(props.travelers));

  React.useEffect(
    () => {
      const lastRoomRef = roomRefs[roomRefs.length - 1];
      if (!!lastRoomRef && !!lastRoomRef.current) {
        lastRoomRef.current.focus();
      }
    },
    [totalRoomRefs]
  );

  return (
    <TravelersPicker
      {...props}
      roomRefs={roomRefs}
      totalRoomRefs={totalRoomRefs}
      setTotalRoomRefs={setTotalRoomRefs}
      travelers={travelers}
      setTravelers={setTravelers}
    />
  );
};
